/**
 * Logos de las compañías, en `public/logos/`.
 *
 * Todos son «TeamSystem | nombre» recortados al ras, con la parte de TeamSystem
 * en la misma proporción, así que a la misma altura se ven del mismo tamaño. El
 * de TS Facturas lleva aire arriba y abajo y necesita más altura para quedar
 * igual. Una compañía sin logo aquí (o cuyo fichero falte) se pinta con el icono
 * de TeamSystem y su nombre.
 */
export interface LogoDeCompania {
  fichero: string;
  /** Altura de la imagen, para igualar el tamaño aparente entre logos. */
  alto: string;
}

const ALTO_ESTANDAR = '1.6rem';

export const LOGOS: Record<string, LogoDeCompania> = {
  SDELSOL: { fichero: 'sdelsol.png', alto: ALTO_ESTANDAR },
  AIG: { fichero: 'aig.webp', alto: ALTO_ESTANDAR },
  APLIFISA: { fichero: 'aplifisa.webp', alto: ALTO_ESTANDAR },
  DISTRITOK: { fichero: 'distritok.png', alto: ALTO_ESTANDAR },
  GOLDENSOFT: { fichero: 'goldensoft.png', alto: ALTO_ESTANDAR },
  QUIPU: { fichero: 'quipu.webp', alto: ALTO_ESTANDAR },
  TSFACTURAS: { fichero: 'tsfacturas.webp', alto: '2.9rem' },
};

/**
 * Iconos de los productos de Software Delsol, en `public/productos/`, por el
 * código del servicio. Un servicio sin icono (o cuyo fichero falte) conserva el
 * icono genérico.
 */
export const ICONOS_PRODUCTO: Record<string, string> = {
  CONTASOL: 'contasol.svg',
  CRMSOL: 'crmsol.svg',
  DELSOL: 'delsol.svg',
  FACTUSOL: 'factusol.svg',
  GDE: 'gde.svg',
  NOMINASOL: 'nominasol.svg',
  REVISO: 'reviso.svg',
  TPVSOL: 'tpvsol.svg',
};
